export interface Rebalance {
  id: ID;
  createdAt: Date;
  recommendations: Recommendation[];
}

export interface Recommendation {
  id: ID;
  ticker: string;
  direction: DirectionType;
  price: number;
  quantity: number;
  amount: number;
  currency: Currency;
}

export enum DirectionType {
  Buy,
  Sell,
}
